/**
 * 用途：无权限访问提示页，当用户访问了没有权限的资源时展示此页面
 * 路由：/forbidden
 */
import { useAppStore } from '../store/useAppStore';
import { generateCodeVerifier, generateCodeChallenge, generateState } from '../lib/pkce';

const GATEKEEPER_URL = (import.meta.env.VITE_GATEKEEPER_URL || 'https://test-gatekeeper.xmslol.cn').replace(/\/+$/, '');
const OAUTH_CLIENT_ID = import.meta.env.VITE_OAUTH_CLIENT_ID || 'ad-platform';
const OAUTH_REDIRECT_URI = import.meta.env.VITE_OAUTH_REDIRECT_URI || `${window.location.origin}/sso/callback`;

export default function Forbidden() {
  async function handleSwitchAccount() {
    // 清掉旧账号的 token 和权限状态
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_info');
    useAppStore.setState({ permissionsLoaded: false, permissionCodes: [], permissionsLoading: false });

    // 构造 PKCE 授权 URL，存好参数
    const verifier = generateCodeVerifier();
    const challenge = await generateCodeChallenge(verifier);
    const state = generateState();
    sessionStorage.setItem('oauth_code_verifier', verifier);
    sessionStorage.setItem('oauth_state', state);
    sessionStorage.setItem('oauth_redirect_after', '/');

    const authorizeUrl = new URL(`${GATEKEEPER_URL}/api/oauth/authorize`);
    authorizeUrl.searchParams.set('client_id', OAUTH_CLIENT_ID);
    authorizeUrl.searchParams.set('redirect_uri', OAUTH_REDIRECT_URI);
    authorizeUrl.searchParams.set('state', state);
    authorizeUrl.searchParams.set('code_challenge', challenge);
    authorizeUrl.searchParams.set('code_challenge_method', 'S256');

    // 先退出 gatekeeper session，再重定向到授权页（此时会显示登录表单）
    const logoutUrl = new URL(`${GATEKEEPER_URL}/api/oauth/logout`);
    logoutUrl.searchParams.set('post_logout_redirect_uri', authorizeUrl.toString());
    window.location.replace(logoutUrl.toString());
  }

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100vh', gap: 12,
      background: '#0b0f19', color: '#9ca3af',
    }}>
      <div style={{ fontSize: 72, fontWeight: 700, color: '#1f2937', lineHeight: 1 }}>403</div>
      <div style={{ fontSize: 18, color: '#d1d5db', marginTop: 8 }}>暂无访问权限</div>
      <div style={{ fontSize: 14, color: '#6b7280', textAlign: 'center', maxWidth: 320 }}>
        你还没有该页面的访问权限，请前往系统管理平台提交权限申请
      </div>
      <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
        <button
          onClick={handleSwitchAccount}
          style={{
            padding: '8px 20px', borderRadius: 8, cursor: 'pointer',
            background: 'transparent', color: '#6b7280',
            border: '1px solid #374151',
          }}
        >
          切换账号登录
        </button>
        <a
          href={import.meta.env.VITE_GATEKEEPER_URL ?? 'https://test-gatekeeper.xmslol.cn'}
          target="_blank"
          rel="noreferrer"
          style={{
            padding: '8px 20px', borderRadius: 8, cursor: 'pointer',
            background: '#4f46e5', color: '#fff',
            border: 'none', textDecoration: 'none', fontSize: 14,
          }}
        >
          去申请权限
        </a>
      </div>
    </div>
  );
}
